export enum EMITTERS {
  VISA = 1,
  MASTER = 2,
  AMEX = 3,
  BAPRO = 5,
  MERCADOPAGO = 8,
  CATAMARCA_CREDITS = 9,
  NARANJA,
}
